import { speed } from 'Lib/speed/speed';

// клик на "Создать новую подборку"
$(document).on('click', '.collection-user-add__signature_drop', function () {
    $(this).closest('.collection-user-add').find('.collection-user-add__form').slideToggle(speed);
});

// Изменение текстового поля добавления подборки
$(document).on('change keyup paste', '.collection-user-add__input', function () {
    const $this = $(this);
    const $btn = $this.closest('.collection-user-add__form').find('.collection-user-add__btn');
    const cBtnDisabled = 'btn_disabled';

    if ($this.val().length > 0) {
        $btn.removeClass(cBtnDisabled).prop('disabled', false);
    } else {
        $btn.addClass(cBtnDisabled).prop('disabled', true);
    }
});

// клик на "Создать подборку" для открытия модального окна
$('.collection-user-add_create').on('click', () => {
    $.fancybox.close();

    $.fancybox.open({
        type: 'html',
        src: $('.collections__modal-content-create').html(),
        baseClass: 'collections__fancybox',
        touch: false,
    });
});

$(document).on('eksmoThisAjaxFormSuccess', '.collection-user-add__form', () => {
    setTimeout(() => {
        window.location.reload(true);
    }, 1500);
});
